import { render } from "./addClub.vue?vue&type=template&id=cae6771c&scoped=true"
import script from "./addClub.vue?vue&type=script&lang=js"
export * from "./addClub.vue?vue&type=script&lang=js"

import "./addClub.vue?vue&type=style&index=0&id=cae6771c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cae6771c"]])

export default __exports__